// const mdyCultures = ["en-us", "en-ca"];
const dmyCultures = ["en-ph", "en-us", "en-zw", "es-us", "fil-ph", "moh-ca", "ne-np", "rw-rw", "sw-ke", "sah-ru", "en-029", "es-pa", "fa-ir", "mn-mn", "en"];
const getIndices = (culture) => {
    const format = dmyCultures.includes(culture.toLowerCase()) ? "mdy" : "dmy";
    const monthIndex = format === "mdy" ? 0 : 1;
    const dayIndex = format === "mdy" ? 1 : 0;
    const yearIndex = 2;
    return { monthIndex, dayIndex, yearIndex };
};
export function toString(culture, value) {
    if (!value)
        return "";
    const { monthIndex, dayIndex, yearIndex } = getIndices(culture);
    const mm = (value.getMonth() + 1).toString().padStart(2, "0");
    const dd = value.getDate().toString().padStart(2, "0");
    const yyyy = `${value.getFullYear()}`;
    const parts = new Array(3);
    parts[monthIndex] = mm;
    parts[dayIndex] = dd;
    parts[yearIndex] = yyyy;
    return parts.join("/");
}
// export function evalDayMonthYear(value: string): Date | undefined {
//     const regex = /^(\+*|-*)(\d+)(m|M|y|Y|d|D)/;
//     const match = regex.exec(value)
//     if (match) {
//         const [, sign, amount, unit = "d"] = match;
//         const multiplier = sign === "-" ? -1 : 1;
//         const dt = new Date();
//         if (unit.toLowerCase() === "d") {
//             dt.setDate(dt.getDate() + (+amount * multiplier));
//             return dt;
//         } else if (unit.toLowerCase() === "m") {
//             dt.setMonth(dt.getMonth() + (+amount * multiplier));
//             return dt;
//         } else if (unit.toLowerCase() === "y") {
//             dt.setFullYear(dt.getFullYear() + (+amount * multiplier));
//             return dt;
//         }
//     }
//     return undefined;
// }
const MONTH = "([0-9]{1,2})";
const DAY = "([0-9]{1,2})";
const YEAR = "([0-9]{4})";
export function pareseDate(culture, value) {
    if (!value)
        return undefined;
    const { monthIndex, dayIndex, yearIndex } = getIndices(culture);
    // const regex = /^([1-9]|0[1-9]|1[012])[- /.]([1-9]|0[1-9]|[12][0-9]|3[01])[- /.]((19|20)\d\d)/;
    const array = new Array(3);
    array[monthIndex] = MONTH;
    array[yearIndex] = YEAR;
    array[dayIndex] = DAY;
    // const array = dateFormat === "dmy" ? [DAY, MONTH, YEAR] : [MONTH, DAY, YEAR];
    const regex = new RegExp(array.join("[.-/]"));
    // const regex = /([0-9]{1,2})[.-/]([0-9]{1,2})[.-/]([0-9]{4})/;
    const x = value.match(regex);
    if (x) {
        const month = x[monthIndex + 1];
        const day = x[dayIndex + 1];
        const year = x[yearIndex + 1];
        // let month: string, day: string, year: string;
        // if (dateFormat === "dmy")
        //     [, day, month, year] = x;
        // else
        //     [, month, day, year] = x;
        if (+month > 12 || +month < 1)
            return undefined;
        if (+day > 31 || +day < 1)
            return undefined;
        return new Date(+year, +month - 1, +day);
    }
    // const {groups: {month, day, year}} = RegExpNamedCaptureGroups.exec('2019-12-31');
    // const match = regex.exec(value);
    // if (match) {
    //     const [, mm, dd, yyyy] = match;
    //     return new Date(+yyyy, +mm - 1, +dd);
    // }
    return undefined;
}
// export function evalCommand(culture: string, value: string): Date | undefined {
//     let date = evalMMDDYYYY(culture, value)
//     return date;
// if (date) return date;
// date = evalDayMonthYear(value);
// if (date) return date;
// return undefined;
// }
